import {
  GET_LOCALE_REQUEST,
  GET_LOCALE_ERROR,
  GET_LOCALE_SUCCESS,
  GET_CONTENT_REQUEST,
  GET_CONTENT_ERROR,
  GET_CONTENT_SUCCESS
} from "../actions/contentActions.js";

const initialState = {
  locale: "au",
  localeData: {
    country: "Australia",
    infoEmail: "info@humanitix.com.au",
    eventEmail: "event@humanitix.com.au",
    nfpEmail: "nfp@humanitix.com.au",
    charitiesEmail: "charities@humanitix.com.au",
    earlyPaymentsEmail: "earlypayment@humanitix.com",
    accountsEmail: "accounts@humanitix.com",
    contactNumber: "0421678193",
    consoleURL: "https://console.humanitix.com",
    ticketURL: "https://events.humanitix.com"
  },
  loading: false,
  error: false,
  success: false,
  confirmed: false,
  bannerClosed: false,
  data: {}
};

const reducer = (state = initialState, action) => {
  let { data } = state;
  switch (action.type) {
    case GET_LOCALE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_LOCALE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        locale: action.locale,
        localeData: action.localeData,
        data: {}
      };
    case GET_LOCALE_ERROR:
      return {
        ...state,
        loading: false,
        locale: action.locale
      };
    case GET_CONTENT_REQUEST:
      data[action.key] = { loading: true };
      return {
        ...state,
        data: data
      };
    case GET_CONTENT_SUCCESS:
      data[action.key] = { loading: false, data: action.data };
      return {
        ...state,
        data: data
      };
    case GET_CONTENT_ERROR:
      data[action.key] = { loading: false, error: true };
      return {
        ...state,
        data: data
      };

    default:
      return state;
  }
};

export default { initialState, reducer };
